/* projects/fitnessforservice/src/app/print-report/print-report-modal/print-report-modal.component.css */
.dialog-container {
  display: flex;
}
.dialog-actions {
  float: right;
}
label {
  color: black;
}
.container {
  margin-top: 5px;
}
/*# sourceMappingURL=print-report-modal.component.css.map */
